import axios from 'axios';
import { AdminRouteData, AdminRouteQueryParams, PaginatedAdminRouteResponse } from '../types/adminRoute';

const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;

export const getRoutesAdmin = async (
  params: AdminRouteQueryParams & {
    page?: number;
    size?: number;
    sortBy?: string;
    sortDir?: string;
  }, 
  adminApiKey: string
): Promise<PaginatedAdminRouteResponse | AdminRouteData[]> => {
  try {
    const url = new URL(`${API_BASE_URL}/api/v2/route/getRouteAdmin`);
    
    // Only add shipmentNumber if provided
    if (params.shipmentNumber && params.shipmentNumber.trim()) {
      url.searchParams.append('shipmentNumber', params.shipmentNumber);
    }
    
    // Handle multiple serial numbers
    if (params.serialNumbers && params.serialNumbers.length > 0) {
      // Join serial numbers with comma delimiter as specified in requirements
      url.searchParams.append('serialNumber', params.serialNumbers.join(','));
    }

    // Add pagination parameters with defaults
    url.searchParams.append('page', (params.page ?? 0).toString());
    url.searchParams.append('size', (params.size ?? 50).toString());
    url.searchParams.append('sortBy', params.sortBy ?? 'id');
    url.searchParams.append('sortDir', params.sortDir ?? 'asc');

    const response = await axios.get(url.toString(), {
      headers: {
        'X-Admin-API-Key': adminApiKey, // Use admin API key instead of Bearer token
        'Content-Type': 'application/json',
      },
    });
    
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 404) {
      // Return empty paginated response for no results
      return {
        content: [],
        pagination: {
          currentPage: params.page ?? 0,
          totalPages: 0,
          totalItems: 0,
          pageSize: params.size ?? 50,
          hasNext: false,
          hasPrevious: false,
        }
      };
    }
    if (error.response?.status === 401) {
      throw new Error('Invalid admin API key');
    }
    if (error.response?.status === 403) {
      throw new Error('Admin access denied');
    }
    throw new Error('Failed to fetch admin routes');
  }
}; 